module.exports = "<a role=\"menuitem\" tabindex=\"0\" ng-click=\"open()\" fs-key-enter=\"open()\"><span wk-icon=\"question\"></span>Help</a>";